import { render, staticRenderFns } from "./chooseImgs.vue?vue&type=template&id=a5377a66&scoped=true"
import script from "./chooseImgs.vue?vue&type=script&lang=js"
export * from "./chooseImgs.vue?vue&type=script&lang=js"
import style0 from "./chooseImgs.vue?vue&type=style&index=0&id=a5377a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5377a66",
  null
  
)

export default component.exports